"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../../utils/common");
const _ = __importStar(require("lodash"));
// build case link depend of case type
const setCaseLink = (activeChat) => {
    let link = `case?id=${activeChat.case.id}`;
    if (activeChat.cr_id) {
        link = `court-report?id=${activeChat.case.id}`;
    }
    else if (activeChat.tr_id) {
        link = `tr-${link}`;
    }
    else if (activeChat.fatt_id) {
        link = `fatt-${link}`;
    }
    else if (activeChat.rc_id) {
        link = `refer-${link}`;
    }
    else {
        return `case?id=${activeChat.case.hashString}`;
    }
    return link;
};
const caseInfo = (caseData, items) => {
    return react_1.default.createElement(react_1.Fragment, null, items.map((val, key) => {
        return (react_1.default.createElement("div", { key: key, className: "case-info-item" },
            react_1.default.createElement("p", { className: "text" }, val.multiple ? `${_.get(caseData, val.key[0])} hours / ${_.get(caseData, val.key[1])} hour(s)` : _.get(caseData, val.key)),
            react_1.default.createElement("span", { className: "sub-text" }, val.title)));
    }));
};
// get case details depending on case type
const getCaseInfo = (activeChat) => {
    let item = null;
    if (activeChat.cr_id) {
        item = caseInfo(activeChat.case, common_1.ITEM_GENERIC_TYPES.cr);
    }
    else if (activeChat.tr_id) {
        item = caseInfo(activeChat.case, common_1.ITEM_GENERIC_TYPES.tr);
    }
    else if (activeChat.fatt_id) {
        item = caseInfo(activeChat.case, common_1.ITEM_GENERIC_TYPES.fatt);
    }
    else if (activeChat.rc_id) {
        item = caseInfo(activeChat.case, common_1.ITEM_GENERIC_TYPES.rc);
    }
    else {
        item = caseInfo(activeChat.case, activeChat.case.appearanceType === 'Deposition' ? common_1.ITEM_GENERIC_TYPES.depo : common_1.ITEM_GENERIC_TYPES.case);
    }
    return item;
};
const CaseInfo = (props) => {
    const { caseData, activeChat } = props;
    return (react_1.default.createElement("div", { className: "case-info-container" },
        react_1.default.createElement("h4", { className: 'title' },
            caseData.genericType || caseData.casetype,
            react_1.default.createElement("a", { target: '_blank', href: `#/${setCaseLink(activeChat)}`, className: "link" }, "View More")),
        getCaseInfo(activeChat)));
};
exports.default = CaseInfo;
